const state = () => ({
    isResetPassword: false,
    isAgreedTerms: false,
    isAgreedPrivacy: false,
    isAgreedTermsPlan: false,
    isSubscriptionStarted: false,
    previousDeeplink: null,
    redirectMessage: null,
    redirectMessageType: null,
})

const mutations = {
    setIsAgreedTerms (state, value) {
        state.isAgreedTerms = value
    },

    setIsAgreedPrivacy (state, value) {
        state.isAgreedPrivacy = value
    },

    setIsAgreedTermsPlan (state, value) {
        state.isAgreedTermsPlan = value
    },

    setIsResetPassword (state, value) {
        state.isResetPassword = value
    },

    setIsSubscriptionStarted (state, value) {
        state.isSubscriptionStarted = value
    },

    setPreviousDeeplink (state, value) {
        state.previousDeeplink = value
    },

    setRedirectMessage (state, value) {
        state.redirectMessage = value
    },

    setRedirectMessageType (state, value) {
        state.redirectMessageType = value
    },
}

const getters = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
